import { Injectable } from '@angular/core';
import { DeadlineContract } from '@core/interfaces/deadlines-contracts';
import { Apollo } from 'apollo-angular';
import { Company, PagedResult } from 'app/core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuerifyService, QueryOptions } from '../services/querify.service';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class DeadlineCotractApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries
  ) {}
  async getDeadlineContractByConfig({ locationId, segmentId, maintenanceTypeId }: { locationId: string, maintenanceTypeId: string, segmentId: string }): Promise<DeadlineContract> {
    return this.apollo
      .query({
        query: this.queries.deadlineContractByConfig(),
        variables: { locationId, maintenanceTypeId, segmentId }
      })
      .toPromise()
      .then(({ data }) => data['deadlineContractByConfig']);
  }


}
